var _circle, _circle2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59.25,
    stroke: "url(#paint0_linear_1074_754)",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.25 51H30.75L60 33L89.25 51Z",
    fill: "url(#paint1_linear_1074_754)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 53.2501H37.5V71.2501H33C32.4033 71.2501 31.831 71.4871 31.409 71.9091C30.9871 72.331 30.75 72.9033 30.75 73.5001C30.75 74.0968 30.9871 74.6691 31.409 75.0911C31.831 75.513 32.4033 75.7501 33 75.7501H87C87.5967 75.7501 88.169 75.513 88.591 75.0911C89.0129 74.6691 89.25 74.0968 89.25 73.5001C89.25 72.9033 89.0129 72.331 88.591 71.9091C88.169 71.4871 87.5967 71.2501 87 71.2501H82.5V53.2501H89.25C89.7396 53.2496 90.2156 53.0894 90.6059 52.7939C90.9962 52.4984 91.2795 52.0837 91.4128 51.6126C91.546 51.1415 91.522 50.6398 91.3444 50.1837C91.1667 49.7275 90.8452 49.3417 90.4284 49.0848L61.1784 31.0848C60.824 30.8668 60.4161 30.7515 60 30.7515C59.5839 30.7515 59.176 30.8668 58.8216 31.0848L29.5716 49.0848C29.1548 49.3417 28.8333 49.7275 28.6556 50.1837C28.478 50.6398 28.454 51.1415 28.5873 51.6126C28.7205 52.0837 29.0038 52.4984 29.3941 52.7939C29.7844 53.0894 30.2604 53.2496 30.75 53.2501ZM42 53.2501H51V71.2501H42V53.2501ZM64.5 53.2501V71.2501H55.5V53.2501H64.5ZM78 71.2501H69V53.2501H78V71.2501ZM60 35.641L81.3019 48.7501H38.6981L60 35.641ZM93.75 82.5001C93.75 83.0968 93.5129 83.6691 93.091 84.0911C92.669 84.513 92.0967 84.7501 91.5 84.7501H28.5C27.9033 84.7501 27.331 84.513 26.909 84.0911C26.4871 83.6691 26.25 83.0968 26.25 82.5001C26.25 81.9033 26.4871 81.331 26.909 80.9091C27.331 80.4871 27.9033 80.2501 28.5 80.2501H91.5C92.0967 80.2501 92.669 80.4871 93.091 80.9091C93.5129 81.331 93.75 81.9033 93.75 82.5001Z",
    fill: "url(#paint2_linear_1074_754)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_754",
    x1: 0,
    y1: 120,
    x2: 90.5973,
    y2: 89.6441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1074_754",
    x1: 30.75,
    y1: 51,
    x2: 53.2241,
    y2: 26.5266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1074_754",
    x1: 26.25,
    y1: 84.7501,
    x2: 74.4727,
    y2: 64.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.905da5fe9b461ed79363e282f9eaa50e.svg";
export { ForwardRef as ReactComponent };